import { Box, Tag, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { UploadProcess } from 'modules/documents/hooks/useGetUploadProcess'

interface Props {
  uploadProcess: UploadProcess
}

const Tags = ({ uploadProcess }: Props) => {
  const statusLabel: Record<string, string> = {
    ['personal_files']: i18n.t('documents.distribution_workflow.personal_files'),
    ['templates']: i18n.t('documents.distribution_workflow.template'),
    ['same_files']: i18n.t('documents.distribution_workflow.same_file_everyone'),
  }

  if (!uploadProcess.distributionWorkflow || uploadProcess.distributionWorkflow === 'same_files')
    return null

  const label = statusLabel[uploadProcess?.distributionWorkflow]

  return (
    <Box alignItems="center" justifyContent="center">
      <Text.Normal size="200" color="grey800">
        <Tag type="champagne">{label}</Tag>
      </Text.Normal>
    </Box>
  )
}

export default Tags
